// Used to generate mock data in the chart building phase to help the user visualize a chart even when there's no actual data for that query. (The data for the exact query can be populated later)

function generateStringValue(alias, index) {
  return `${alias.split(' ').pop()} ${index + 1}`;
}

function generateNumericValue(_alias, _index, is_aggregation) {
  if (is_aggregation) {
    return Math.round(Math.random() * 10000) / 100;
  }
  return Math.round(Math.random() * 1000);
}

function generateDateValue(_alias, index) {
  const base = new Date(2025, 0, 1);
  base.setDate(base.getDate() + (index * 7));
  return base.toISOString().split('T')[0];
}

function generateTimestampValue(_alias, index) {
  const base = new Date(2025, 0, 1, 9, 0, 0);
  base.setDate(base.getDate() + index);
  base.setHours(9 + (index % 8));
  return base.toISOString();
}

function generateBooleanValue(_alias, index) {
  return index % 2 === 0;
}

function getEffectiveFieldType(column) {
  if (column.field_type)
    return column.field_type;
  if (column.expr)
    return 'numeric';
  return 'text';
}

function generateValueForType(field_type, alias, index, is_aggregation) {
  switch (field_type) {
    case 'string':
    case 'text':
    case 'text_array':
      return generateStringValue(alias, index);

    case 'numeric':
    case 'integer':
    case 'decimal':
    case 'float':
      return generateNumericValue(alias, index, is_aggregation);

    case 'date':
    case 'time':
      return generateDateValue(alias, index);

    case 'timestamp':
    case 'datetime':
    case 'timestamptz':
      return generateTimestampValue(alias, index);

    case 'boolean':
      return generateBooleanValue(alias, index);

    default:
      return generateStringValue(alias, index);
  }
}

function mapFieldTypeToMetadataType(field_type) {
  switch (field_type) {
    case 'string':
    case 'text':
    case 'text_array':
      return 'text';
    case 'numeric':
    case 'integer':
    case 'decimal':
    case 'float':
      return 'numeric';
    case 'date':
    case 'time':
      return 'date';
    case 'timestamp':
    case 'datetime':
    case 'timestamptz':
      return 'timestamp';
    case 'boolean':
      return 'boolean';
    default:
      return 'text';
  }
}

export function generateMockData(stages, rowCount = 15) {
  const columns = [];

  stages.forEach((stage) => {
    stage?.columns?.forEach((column) => {
      if (!column.skip && column.alias && !columns.find(c => c.alias === column.alias)) {
        columns.push(column);
      }
    });
  });

  if (!columns.length) {
    return { data: [], metadata: { columns: [] } };
  }

  const resolved_columns = columns.map(col => ({
    ...col,
    _resolved_type: getEffectiveFieldType(col),
  }));

  const metadata = {
    columns: resolved_columns.map(col => ({
      name: col.alias,
      type: mapFieldTypeToMetadataType(col._resolved_type),
    })),
  };

  const data = [];
  for (let i = 0; i < rowCount; i++) {
    const row = {};
    resolved_columns.forEach((col) => {
      row[col.alias] = generateValueForType(
        col._resolved_type,
        col.alias,
        i,
        col.is_aggregation,
      );
    });
    data.push(row);
  }

  return { data, metadata };
}
